export function localStorageGet(key: string) {
  const item = localStorage.getItem(key);
  if (item !== 'undefined' && item) {
    try {
      return JSON.parse(item);
    } catch {
      // Value isn't JSON (e.g. a raw token, or a stale/hand-set value). Return it as-is
      // rather than throwing an uncaught error that surfaces React's red dev overlay.
      return item;
    }
  }
}

export function localStorageSet(key: string, item: any) {
  localStorage.setItem(key, JSON.stringify(item));
}
